import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { ThemeContext } from "../context/themeContext";
import "./MobileChatFAB.css";

export default function MobileChatFAB() {
  const navigate = useNavigate();
  const { activeTheme } = useContext(ThemeContext);

  return (
    <button
      className={`mobile-chat-fab ${activeTheme === "dark" ? "dark-mode" : ""}`}
      onClick={() => navigate("/mm-ai")}
      aria-label="Open MarsMate AI Chat"
    >
      <img
        src="/image/logo-perfect-1.png"
        alt="MM AI"
        className="mobile-chat-fab-img"
      />
    </button>
  );
}
